import { Component, ChangeDetectionStrategy, inject, input } from '@angular/core';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { MatTooltip } from '@angular/material/tooltip';
import { NgClass } from '@angular/common';
import { DefaultClassDirective } from '@ngbracket/ngx-layout/extended';

@Component({
	selector: 'ara-editor-menu',
	templateUrl: './ara-editor-menu.component.html',
	styleUrls: ['./ara-editor-menu.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [TranslocoDirective, MatTooltip, NgClass, DefaultClassDirective],
})
export class AraEditorMenuComponent {
	translocoService = inject(TranslocoService);

	readonly editor = input<any>(undefined);
}
